import { ComponentPropsWithoutRef, useState } from 'react';

import { Row } from '@tanstack/react-table';
import {
  NotificationRule,
  NotificationRuleStatuses,
} from '@/features/notification-rules/schemas/notification-rules.schema.ts';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx';
import { EditIcon } from 'lucide-react';
import { LoaderIcon } from '@/assets/loader-icon.tsx';
import { usePatchNotificationRulesMutation } from '@/features/notification-rules/hooks/mutations/use-patch-notification-rules.ts';

interface DeleteNotificationRulesDialogProps extends ComponentPropsWithoutRef<
  typeof DropdownMenu
> {
  notificationRules: Row<NotificationRule>['original'][];
  onSuccess?: () => void;
  showTrigger?: boolean;
}

export function NotificationRulesTableToolbarEditDropdown({
  notificationRules,
  onSuccess,
}: DeleteNotificationRulesDialogProps) {
  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = useState(false);

  const isLoading = false;

  const { mutate } = usePatchNotificationRulesMutation({
    onSuccess: () => {
      onSuccess?.();
      setIsDropdownMenuOpen(false);
    },
  });

  const onSubmit = (status: NotificationRuleStatuses) => {
    mutate(
      notificationRules.map(({ notificationRuleId }) => ({
        notificationRuleId,
        status,
      }))
    );
  };

  return (
    <DropdownMenu open={isDropdownMenuOpen} onOpenChange={setIsDropdownMenuOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="flex w-min gap-2">
          {isLoading ? (
            <LoaderIcon className="size-3.5 animate-spin" />
          ) : (
            <>
              <EditIcon className="size-4" aria-hidden="true" />
              <span className="hidden sm:inline-block">Edit ({notificationRules.length})</span>
            </>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuSub>
          <DropdownMenuSubTrigger>Status</DropdownMenuSubTrigger>
          <DropdownMenuPortal>
            <DropdownMenuSubContent>
              <DropdownMenuItem
                onClick={() => {
                  onSubmit('enabled');
                }}
              >
                Enabled
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => {
                  onSubmit('disabled');
                }}
              >
                Disabled
              </DropdownMenuItem>
            </DropdownMenuSubContent>
          </DropdownMenuPortal>
        </DropdownMenuSub>
        {/*<DropdownMenuItem>Edit</DropdownMenuItem>*/}
        {/*<DropdownMenuItem>Delete</DropdownMenuItem>*/}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default NotificationRulesTableToolbarEditDropdown;
